import { SET_SUPERUSER_SCHOOL_TABLE_SCROLL } from "../actions/scrollActions";

export function scrollReducer(
  state = {
    superuserSchoolTableScroll: null,
    error: null,
  },
  action
) {
  switch (action.type) {
    case SET_SUPERUSER_SCHOOL_TABLE_SCROLL: {
      return { ...state, superuserSchoolTableScroll: action.payload };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
